import { AddCommentOutlined as AddCommentIcon } from '@mui/icons-material';
import { IconButton, type IconButtonProps } from '@mui/material';
import styled from '@emotion/styled';
import stripProps from '@/lib/utils/stripProps';

type StyledIconButtonProps = IconButtonProps & {
  isInLogEntry: boolean;
};

const StyledIconButton = styled(
  stripProps(IconButton, 'isInLogEntry'),
)<StyledIconButtonProps>(({ isInLogEntry }) => ({
  position: 'absolute',
  top: isInLogEntry ? 14 : -8,
  right: isInLogEntry ? 16 : 0,
}));

type MobileCoachCommentButtonProps = Omit<IconButtonProps, 'children'> & {
  isInLogEntry: boolean;
};

const MobileCoachCommentButton = (props: MobileCoachCommentButtonProps) => (
  <StyledIconButton {...props}>
    <AddCommentIcon />
  </StyledIconButton>
);

export default MobileCoachCommentButton;
